import { render, staticRenderFns } from "./OrderRow.vue?vue&type=template&id=3bfafe58&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./OrderRow.vue?vue&type=script&lang=ts"
export * from "./OrderRow.vue?vue&type=script&lang=ts"
import style0 from "./OrderRow.vue?vue&type=style&index=0&id=3bfafe58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfafe58",
  null
  
)

export default component.exports